import { ACS_LOGO } from "@/lib/api";

export const Brand = ({ compact = false, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="acs-brand">
    <img
      src={ACS_LOGO}
      alt="Alabama Church School Logo"
      className="h-10 w-10 rounded-full object-cover ring-1 ring-slate-200"
    />
    {!compact && (
      <div className="leading-tight">
        <div className="font-display text-[15px] font-bold text-slate-900">
          Alabama Church School
        </div>
        <div className="text-[11px] uppercase tracking-[0.14em] text-slate-500">
          Partner Portal
        </div>
      </div>
    )}
  </div>
);
